import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SchoolsettingsService {

  constructor(private  httpClient: HttpClient) {
  }

  postTestEmailSms(testdata) {
    return this.httpClient.post('/schoolsettings/general_checklist/', testdata);
  }

   getGeneralChecklist() {
    return this.httpClient.get('/schoolsettings/general_checklist/');
  }
  

  getfeedbackuser() {
    return this.httpClient.get('/schoolsettings/feedback_details/');
  }

 	changefeedback(feedback_id, status) {
    return this.httpClient.get('/schoolsettings/change_feedback/', { params: { 'id': feedback_id, status } });
  }

  getAcademicYears() {
      return this.httpClient.get('/schoolsettings/academic_year/');
  }
  
  changeActiveAcademicyear(academicyear) {
      return this.httpClient.post('/schoolsettings/academic_year/', academicyear);
  }

  getEmployeeCreationSettings(params){
    return this.httpClient.get("/dashboard/employee_creation_settings/",{params:params})
  }

  postEmployeeCreationSettings(data){
    return this.httpClient.post("/dashboard/employee_creation_settings/",data)
  }

  postUserProfileUpdate(data){
    return this.httpClient.post("/dashboard/user_profile_update_enable/",data)
  }

  getUserProfileUpdate(){
    return this.httpClient.get("/dashboard/user_profile_update_enable/")
  }




  GetParentProfileUpdate(){
    return this.httpClient.get("/dashboard/user_profile_parent_update_enable/")
  }

  postParentProfileUpdate(data){
    return this.httpClient.post("/dashboard/user_profile_parent_update_enable/",data)
  }

  getStudentCreationSettings(params){
    return this.httpClient.get("/dashboard/parent_creation_settings/",{params : params})
  }

  postStudentCreationSettings(data){
    return this.httpClient.post("/dashboard/parent_creation_settings/",data)
  }
} 